import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from "../../_services/authentication.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs'

@Component({ templateUrl: 'login.component.html' })
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    data: any;

    errorMessage = undefined;
    error=false

    subscription: Subscription
    errorSubscription: Subscription

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        this.error=false;
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required,Validators.email] ],
            password: ['', [Validators.required,Validators.minLength(6)]]
        });
                
        this.subscription = this.authenticationService.currentUser.subscribe(message=>{ 
          this.loading = false;
          this.errorMessage= null;
          this.error = false;
          this.data = message;
          if (this.authenticationService.isAuth()){
            this.router.navigateByUrl("/");          
          }
          
        });

        this.errorSubscription = this.authenticationService.errorObservable.subscribe(message=>{
            if (message){      
                this.loginForm.patchValue({
                    password: ''
                });
                this.errorMessage = message;
                this.loading = false;            
                this.error = true;                
            }            
        });
    }

    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.error = false;
        this.errorMessage = undefined;
        this.submitted = true;
        this.data = null;    
        
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.email.value, this.f.password.value);        
    }
}
